import { get } from 'lodash'
import { useQuery } from 'react-query'
import { AxiosError } from 'axios'

import { fetchAPI } from '@/lib/api'

import { User } from '../types'
import { Meta } from '@/features/filters/types'

import { USERS } from '../constants'

type UserResponse = {
  data: User[]
  meta: Meta
}

const getUsers = async (params: Meta): Promise<UserResponse> => {
  const response = await fetchAPI({
    path: `/users`,
    params,
  })
  const data = get(response, 'data.users', [])
  const meta = get(response, 'data.meta', {})

  return { data, meta }
}

export const useUsers = ({
  params = {},
  initialData,
}: {
  params?: Meta
  initialData?: UserResponse
}) => {
  return useQuery<UserResponse, AxiosError>({
    queryKey: [USERS, params],
    queryFn: () => getUsers(params),
    keepPreviousData: true,
    initialData,
  })
}
